import React, { useState } from "react";
import ApplicationsSection from "./components/ApplicationsSection";

const App = ({properties}) => {
  const { vocabId, delta } = properties;
  return (
    <div className="applications-container">
      <ApplicationsSection vocabId={vocabId} delta={delta} />
    </div>
  );
};

export default App;
